import TextInputWeex from "../elements/TextInputWeex";
import NumberInputWeex from "../elements/NumberInputWeex";
import SelectWeex from "../elements/SelectWeex";
import LabelWeex from "../elements/LabelWeex";
import {ElementStyles} from "../elements/ElementStyles";

export default function ComponentContentView ({component, addComponent, tagsOptions, ...props}) {
  const scoreStyles = [{label: "Reps", value: 0}, {label: "Time", value: 1}, {label: "Time + Reps", value: 2}, {label: "Rds. + Reps", value: 3}, {label: "Weight", value: 4}, {label: "Weight + Reps", value: 5}, {label: "None", value: -1}];
  const scoreType = component.scoreType?? scoreStyles[scoreStyles.length - 1]
  const name = component.name
  const description = component.description
  const rounds = component.rounds
  const timer = component.timecap
  const notes = component.note
  const tags = [...component.tags]

  const styles = {
    container: {
      borderRadius: ElementStyles.borderRadius,
      boxSizing: "inherit",
      background: "var(--background)",
      color: ElementStyles.color2,
      minHeight: ElementStyles.height,
      alignItems: "center",
      textWrap: "noWrap"
    },
    labels: {background: "transparent", color: ElementStyles.color}
  }

  return(<div style={styles.container} {...props}>
    <TextInputWeex placeholder={"Name"} value={name} readOnly={true} label={"Name"}/>
    <br/>
    <TextInputWeex placeholder={"Beschreibung"} value={description} rows={15} readOnly={true} label={"Beschreibung"}/>
    <br/>
    <div style={{display: "flex", justifyContent: "space-between"}}>
      <div style={{display: "flex"}}>
        <NumberInputWeex value={rounds} label={"Runden"}/>
        <LabelWeex>Whg.</LabelWeex>
    </div>
    <br/>
    <div style={{display: "flex"}}>
        <TextInputWeex placeholder={"Timer"} value={timer} readOnly={true} label={"Cap"}/>
        <LabelWeex style={styles.labels}>min</LabelWeex>
      </div>
    </div>
    <br/>
    <SelectWeex options={scoreStyles} isMulti={false} isClearable={false} placeholder={"Kein Scoring"} valueRaw={scoreType} isDisabled={true} label={"Score Type"}/>
    <br/>
    <TextInputWeex value={notes} readOnly={true} placeholder={"Keine Notiz"} label={"Note"}/>
    <br/>
    <SelectWeex isDisabled={true} isMulti={true} placeholder={"Keine Tags"} style={{...styles.labels}}
                value={tagsOptions.filter(e=>tags.find(f=>f===e.value))} label={"Tags"}/>
    <br/>
    <button className={"primarybutton"} onClick={()=>addComponent(component)}>Hinzufügen</button>
  </div>)
}